/* Shop grid: client-side filter + sort, faithful to the Next.js ShopClient.
   Brand/Finish/Shape filter over data-attributes; sort by newest/oldest (date
   posted), price asc, price desc. Filters toggle shows/hides the sidebar. */
(function () {
  var root = document.querySelector('[data-shop]');
  if (!root) return;

  var grid = root.querySelector('[data-grid]');
  var sidebar = root.querySelector('[data-sidebar]');
  var toggle = root.querySelector('[data-filters-toggle]');
  var sortWrap = root.querySelector('[data-sort]');
  var sortTrigger = root.querySelector('[data-sort-trigger]');
  var sortPanel = root.querySelector('[data-sort-panel]');
  var sortLabel = root.querySelector('[data-sort-label]');
  var sortOptions = root.querySelectorAll('[data-sort-value]');
  var options = root.querySelectorAll('.shop__option');
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.shop__card'));
  var emptyEl = root.querySelector('[data-empty]');

  var state = { brand: 'all', finish: 'all', shape: 'all', sort: 'newest' };

  function activeCount() {
    return (state.brand !== 'all' ? 1 : 0) + (state.finish !== 'all' ? 1 : 0) + (state.shape !== 'all' ? 1 : 0);
  }

  // A facet value may be a group ("rectangle,square"); a card matches if its
  // value is 'all' or is one of the comma-separated values in the selection.
  function matches(selected, value) {
    return selected === 'all' || selected.split(',').indexOf(value) !== -1;
  }

  function apply() {
    // Filter
    var visible = 0;
    cards.forEach(function (card) {
      var ok = matches(state.brand, card.dataset.brand) && matches(state.finish, card.dataset.finish) && matches(state.shape, card.dataset.shape);
      card.classList.toggle('is-hidden', !ok);
      if (ok) visible++;
    });
    if (emptyEl) emptyEl.classList.toggle('is-hidden', visible !== 0);

    // Sort (reorder DOM among visible + hidden alike)
    var sorted = cards.slice().sort(function (a, b) {
      if (state.sort === 'price-asc') return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
      if (state.sort === 'price-desc') return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
      if (state.sort === 'oldest') {
        // oldest -> date posted asc, tie-broken by original order
        var dco = parseInt(a.dataset.created, 10) - parseInt(b.dataset.created, 10);
        if (dco !== 0) return dco;
        return parseInt(a.dataset.index, 10) - parseInt(b.dataset.index, 10);
      }
      // newest -> date posted desc, tie-broken by original order
      var dc = parseInt(b.dataset.created, 10) - parseInt(a.dataset.created, 10);
      if (dc !== 0) return dc;
      return parseInt(a.dataset.index, 10) - parseInt(b.dataset.index, 10);
    });
    sorted.forEach(function (card) { grid.appendChild(card); });

    // Update Filters label count
    var n = activeCount();
    toggle.textContent = 'Filters' + (n ? ' (' + n + ')' : '');
  }

  options.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var facet = btn.dataset.facet;
      state[facet] = btn.dataset.value;
      // update active styling within this facet group
      root.querySelectorAll('.shop__option[data-facet="' + facet + '"]').forEach(function (o) {
        o.classList.toggle('is-active', o === btn);
      });
      apply();
    });
  });

  function closeSort() {
    sortPanel.classList.add('is-hidden');
    sortTrigger.setAttribute('aria-expanded', 'false');
  }

  sortTrigger.addEventListener('click', function (e) {
    e.stopPropagation();
    var open = sortPanel.classList.toggle('is-hidden') === false;
    sortTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  sortOptions.forEach(function (opt) {
    opt.addEventListener('click', function () {
      state.sort = opt.dataset.sortValue;
      sortLabel.textContent = opt.textContent;
      sortOptions.forEach(function (o) { o.classList.toggle('is-selected', o === opt); });
      closeSort();
      apply();
    });
  });

  // Close the sort panel on any outside click.
  document.addEventListener('click', function (e) {
    if (!sortWrap.contains(e.target)) closeSort();
  });

  toggle.addEventListener('click', function () {
    var open = sidebar.classList.toggle('is-hidden') === false;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  apply();
})();
